









































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { getAllData } from '@/utils/api/setting'
import { Getter } from 'vuex-class'
import MyDialog from './MyDialog.vue'

type ExportFormat = 'JSON'

interface ExportForm {
  exportFormat: ExportFormat
  allConnections: boolean
}

@Component({
  components: {
    MyDialog,
  },
})
export default class ExportData extends Vue {
  @Getter('currentTheme') private theme!: Theme

  @Prop({ default: undefined }) public connection!: ConnectionModel
  @Prop({ default: false }) public visible!: boolean

  private showDialog: boolean = this.visible
  private confirmLoading: boolean = false
  private record: ExportForm = {
    exportFormat: 'JSON',
    allConnections: false,
  }

  @Watch('visible')
  private onVisibleChanged(val: boolean) {
    this.showDialog = val
  }

  private exportData() {
    switch (this.record.exportFormat) {
      case 'JSON':
        this.exportJSONData()
        break
      default:
        break
    }
  }

  private exportDiffFormatData(content: string, format: ExportFormat) {
    const filename = 'data'
    const fileExt = format.toLowerCase()
    if (!this.record.allConnections) {
      // TODO: export single connection
    }
    const blob = new Blob([content], { type: 'text/plain' })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `${filename}.${fileExt}`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    this.$message.success(this.$tc('common.exportSuccess'))
    this.resetData()
  }

  private async getContent() {
    let data: $TSFixed
    if (!this.record.allConnections) {
      // TODO: export single connection
    } else {
      data = getAllData()
    }
    return data
  }

  private async getStringifyContent() {
    const connections = await this.getContent()
    return JSON.stringify(connections, null, 2)
  }

  private exportJSONData() {
    this.confirmLoading = true
    this.getStringifyContent()
      .then((content) => {
        this.exportDiffFormatData(content, 'JSON')
      })
      .catch((err) => {
        this.$message.error(err.toString())
      })
      .finally(() => {
        this.confirmLoading = false
      })
  }

  private resetData() {
    this.showDialog = false
    this.$emit('update:visible', false)
  }

  private created() {
    this.record.allConnections = !this.connection ? true : false
  }
}
